import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  Divider,
  Heading,
  Button,
  ModalProps,
} from '@chakra-ui/react';
import { ChakraCloseIcon } from '../../atoms/ChakraCloseIcon';

interface ModalWithHeaderProps {
  onCancel: () => void;
  onSubmit: () => void;
  isOpen: boolean;
  title: string;
  children: React.ReactElement;
  cancelText: string;
  submitText: string;
  isEditable: boolean;
  size?: ModalProps['size'];
}

const ModalWithHeader = ({
  onCancel,
  isOpen,
  title,
  children,
  cancelText,
  submitText,
  onSubmit,
  isEditable,
  size = '2xl',
}: ModalWithHeaderProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} size={size}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          p={0}
          marginY={8}
          marginX={8}
        >
          <Heading variant="headingmodal">{title}</Heading>
          <ChakraCloseIcon onClick={onCancel} />
        </ModalHeader>
        <Divider />
        <ModalBody px={8} pt={8} pb={6}>
          {children}
        </ModalBody>
        <Divider />

        <ModalFooter display="flex" justifyContent="center" alignItems="center" mX={0} mY={2}>
          {isEditable ? (
            <>
              <Button onClick={onCancel} variant="outline" mr={2}>
                {cancelText}
              </Button>
              <Button onClick={onSubmit}>{submitText}</Button>
            </>
          ) : (
            <Button
              onClick={onCancel}
              variant="outline"
              _hover={{
                bgColor: 'white',
                borderColor: 'border.base',
                border: 'medium',
              }}
            >
              Close
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

ModalWithHeader.displayName = 'ModalWithHeader';

export default ModalWithHeader;
